import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=97895052&"
import script from "./Support.vue?vue&type=script&lang=babel&"
export * from "./Support.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports